const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/audit-logs.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/audit-logs')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/* ─── Types ───────────────────────────────────────────────────────────────── */

interface AuditLog {
  id: string;
  businessId: string;
  actorClerkId: string;
  actorName: string;
  action: string;
  entityType: string;
  entityId: string | null;
  details: Record<string, unknown> | null;
  ipAddress: string | null;
  createdAt: string;
}
interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/* ─── Action colors & labels ──────────────────────────────────────────────── */

/* ─── Unique action values for filter ─────────────────────────────────────── */

/* ─── Component ───────────────────────────────────────────────────────────── */